import { useState } from "react";
import { apiGet } from "../api/api";

export default function RelatorioCampanhas() {
  const [inicio, setInicio] = useState("");
  const [fim, setFim] = useState("");
  const [dados, setDados] = useState([]);
  const [operadorFiltro, setOperadorFiltro] = useState("TODOS");

  async function carregar() {
    if (!inicio || !fim) return;

    const res = await apiGet(
      `/relatorios/campanhas?data_inicio=${inicio}&data_fim=${fim}`
    );
    setDados(res);
  }

  // ===============================
  // OPERADORES (COLUNAS)
  // ===============================
  const operadores = Array.from(
    new Set(dados.map((d) => d.operador))
  ).sort();

  // ===============================
  // DADOS FILTRADOS POR OPERADOR
  // ===============================
  const dadosFiltrados =
    operadorFiltro === "TODOS"
      ? dados
      : dados.filter((d) => d.operador === operadorFiltro);

  // ===============================
  // RESUMO PIVOT (Marca x Operador)
  // ===============================
  const resumoPivot = Object.values(
    dadosFiltrados.reduce((acc, item) => {
      const marca = item.marca || "(Sem marca)";

      if (!acc[marca]) {
        acc[marca] = {
          marca,
          total: 0,
        };
        operadores.forEach((op) => {
          acc[marca][op] = 0;
        });
      }

      acc[marca][item.operador] += item.faces;
      acc[marca].total += item.faces;

      return acc;
    }, {})
  ).sort((a, b) => b.total - a.total);

  return (
    <div style={{ padding: 20 }}>
      <h1>📊 Relatório de Campanhas</h1>

      {/* Filtros */}
      <div style={{ marginBottom: 20 }}>
        <label>Início: </label>
        <input
          type="date"
          value={inicio}
          onChange={(e) => setInicio(e.target.value)}
        />

        <label style={{ marginLeft: 10 }}>Fim: </label>
        <input
          type="date"
          value={fim}
          onChange={(e) => setFim(e.target.value)}
        />

        <label style={{ marginLeft: 10 }}>Operador: </label>
        <select
          value={operadorFiltro}
          onChange={(e) => setOperadorFiltro(e.target.value)}
        >
          <option value="TODOS">Todos</option>
          {operadores.map((op) => (
            <option key={op} value={op}>
              {op}
            </option>
          ))}
        </select>

        <button onClick={carregar} style={{ marginLeft: 10 }}>
          Aplicar
        </button>
      </div>

      {/* ===============================
          TABELA RESUMO PIVOT
      =============================== */}
      {resumoPivot.length > 0 && (
        <>
          <h3>📌 Resumo por Marca e Operador</h3>

          <table width="100%" border="1" cellPadding="6">
            <thead style={{ background: "#f5f5f5" }}>
              <tr>
                <th>Marca</th>
                {operadores.map((op) => (
                  <th key={op}>{op}</th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {resumoPivot.map((r, i) => (
                <tr key={i}>
                  <td>{r.marca}</td>
                  {operadores.map((op) => (
                    <td
                      key={op}
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {r[op] || 0}
                    </td>
                  ))}
                  <td
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      background: "#eee",
                    }}
                  >
                    {r.total}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* ===============================
          TABELA DETALHE
      =============================== */}
      <h3 style={{ marginTop: 40 }}>📋 Detalhe por Campanha</h3>

      <table width="100%" border="1" cellPadding="6">
        <thead style={{ background: "#eee" }}>
          <tr>
            <th>Marca</th>
            <th>Campanha</th>
            <th>Operador</th>
            <th>Nº Faces</th>
          </tr>
        </thead>
        <tbody>
          {dadosFiltrados.map((d, i) => (
            <tr key={i}>
              <td>{d.marca}</td>
              <td>{d.campanha}</td>
              <td>{d.operador}</td>
              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                {d.faces}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
